import doc from "assets/images/v2/Doc_Primary.svg";
import x_mark from "assets/images/v2/x.svg";
import "./DocumentUploadBar.scss";
import classNames from "classnames";
import { GLOBAL_LINK_NO_TX_CLASS } from "utilities/globalLinkNoTx";
import { Spinner } from "../spinner/spinner";
import { formatUploadedDateTime } from "../document-card/DocumentCard";

export enum DocumentUploadBarStatus {
  Error = "Error",
  Attached = "Attached",
  InProgress = "InProgress",
  SubmitSuccess = "SubmitSuccess",
}

interface DocumentUploadBarProps {
  readonly documentName: string;
  readonly documentSize: string;
  readonly documentSubmittedTimeStamp?: string;
  readonly documentUploadStatus: DocumentUploadBarStatus;
  readonly errorMessage?: string;
  readonly showFileIcon?: boolean;
  readonly onRemove?: () => void;
}

export default function DocumentUploadBar({
  documentName,
  documentSize,
  documentSubmittedTimeStamp = "",
  documentUploadStatus,
  onRemove,
  errorMessage,
  showFileIcon = true,
}: DocumentUploadBarProps) {
  const isError = documentUploadStatus === DocumentUploadBarStatus.Error;
  const hasRemoveOption = isError || documentUploadStatus === DocumentUploadBarStatus.Attached;
  const isInProgress = documentUploadStatus === DocumentUploadBarStatus.InProgress;
  const isSubmitSuccess = documentUploadStatus === DocumentUploadBarStatus.SubmitSuccess;

  const getStatusText = (): string => {
    if (isError) {
      const fileErrorMessage = typeof errorMessage === "string" ? errorMessage : "";
      return `${documentSize} ${fileErrorMessage}`;
    }

    if (isSubmitSuccess) return `Submitted ${formatUploadedDateTime(documentSubmittedTimeStamp)}`;

    return typeof documentSize === "string" ? documentSize : "";
  };
  const docUploadBarClass = classNames("doc-upload-bar", {
    "doc-upload-bar--error": isError,
  });

  return (
    <div className={docUploadBarClass}>
      <div className="doc-upload-bar__file-meta">
        {showFileIcon && <img src={doc} className="doc-upload-bar__file-icon" alt="PDF file icon" />}
        <div className="doc-upload-bar__file-details">
          <div className={`doc-upload-bar__file-name ${GLOBAL_LINK_NO_TX_CLASS}`} data-testid="document-file-name" title={documentName}>
            {documentName}
          </div>
          {!isInProgress && <div className="doc-upload-bar__file-status">{getStatusText()}</div>}
        </div>
      </div>

      {isInProgress && (
        <div className="doc-upload-bar__upload-spinner">
          <Spinner />
        </div>
      )}

      {hasRemoveOption && (
        <button type="button" className="doc-upload-bar__remove-button" aria-label="Remove file" onClick={onRemove}>
          <img src={x_mark} alt="" />
        </button>
      )}
    </div>
  );
}
